import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CoreProvidersModule } from 'app/core/core-providers.module';
import { AuthService } from 'app/shared/auth/auth.service';

import { LeafHostComponent } from './leaf-host.component';
import { LeafEmptyRouteComponent } from './leaf-empty-route.component';
import { RUNNING_IN_LEAF_HOST } from './leaf-context.token';
import { LEAF_ROUTES } from './leaf-routes';
import { inicializarHidratacaoSessao } from './hydrate-session.initializer';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreProvidersModule,
    // enabledNonBlocking: navega para a hash atual e carrega a feature migrada correspondente.
    RouterModule.forRoot(LEAF_ROUTES, { useHash: true, initialNavigation: 'enabledNonBlocking' }),
  ],
  declarations: [LeafHostComponent, LeafEmptyRouteComponent],
  providers: [
    // Ausente no AppModule: serviços root compartilhados usam isso para saber que rodam sem chrome.
    { provide: RUNNING_IN_LEAF_HOST, useValue: true },
    {
      provide: APP_INITIALIZER,
      useFactory: inicializarHidratacaoSessao,
      deps: [AuthService, TranslateService],
      multi: true,
    },
  ],
  bootstrap: [LeafHostComponent],
})
export class LeafHostModule {}
